import { Factory } from '../interface/factory'
import { applyEntitySchema, objectSchema, optionalTolerant, sourceJson } from '../../_utils/fcdc-v2'
import * as z from 'zod'

const codeSchema = objectSchema({
  code: optionalTolerant(z.string()),
  expiry: optionalTolerant(z.union([z.string(), z.number()])),
})

export class Code {
  code: string
  expiry: Date

  constructor(json: any) {
    const source = sourceJson(json) as any
    this.code = source.code
    this.expiry = new Date(source.expiry)
    applyEntitySchema(this, codeSchema, source, {})
  }

  static getFactory(): Factory<Code> {
    return new (class implements Factory<Code> {
      make(json: any): Code {
        return new Code(json)
      }

      getTableName(): string {
        throw new Error(
          'getTableName() should never be called on a Code. Codes are not stored in IndexDB.'
        )
      }
    })()
  }
}
